import React from 'react';

const SecurityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2L3 7V12C3 16.97 6.85 21.46 12 22C17.15 21.46 21 16.97 21 12V7L12 2ZM12 20C7.95 19.53 5 15.84 5 12V8.35L12 4.5L19 8.35V12C19 15.84 16.05 19.53 12 20Z"
      fill="currentColor"
    />
    <path
      d="M12 6L7 9V12C7 15.31 9.19 18.32 12 19C14.81 18.32 17 15.31 17 12V9L12 6Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
  </svg>
);

export default SecurityIcon;
